var _defs, _path, _path2, _circle, _path3, _circle2, _path4, _circle3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBmInventory = function SvgBmInventory(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.149,6.6a.372.372,0,0,0,.294-.138L16.285,1.38a.414.414,0,0,0,.114-.306.414.414,0,0,0-.114-.312l-.6-.6A.372.372,0,0,0,15.391,0a.426.426,0,0,0-.306.138L11.149,4.284,9.313,2.352a.4.4,0,0,0-.306-.138.354.354,0,0,0-.288.138l-.6.6a.438.438,0,0,0-.12.33.426.426,0,0,0,.114.318l2.742,2.868a.372.372,0,0,0,.294.132Z",
    transform: "translate(-3.199)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9,15.6a.6.6,0,0,0,.6.6H21A.6.6,0,0,0,21,15H9.6A.6.6,0,0,0,9,15.6Z",
    transform: "translate(-3.6 -6)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.2,
    cy: 1.2,
    r: 1.2,
    transform: "translate(0 8.4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21,21H9.6a.6.6,0,0,0,0,1.2H21A.6.6,0,0,0,21,21Z",
    transform: "translate(-3.6 -8.4)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.2,
    cy: 1.2,
    r: 1.2,
    transform: "translate(0 12)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21,27H9.6a.6.6,0,1,0,0,1.2H21A.6.6,0,0,0,21,27Z",
    transform: "translate(-3.6 -10.8)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.2,
    cy: 1.2,
    r: 1.2,
    transform: "translate(0 15.6)"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBmInventory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BM_Inventory.6910be55.svg";
export { ForwardRef as ReactComponent };